module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    green: '#89c429',
                    blue: '#4dc4e4',
                    orange: '#ffa702',
                    pink: '#dc3f9e',
                    beige: '#fff3dd',
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
